const SUPPORT_CONVERSATIONS_FEATURE_KEY_PREFIX = 'support-conversations-feature-seen:';

const buildSupportFeatureKey = (userId) => `${SUPPORT_CONVERSATIONS_FEATURE_KEY_PREFIX}${userId || 'anonymous'}`;

export const hasSeenSupportConversationsFeature = (userId) => {
  if (typeof window === 'undefined' || !userId) return false;
  return window.localStorage.getItem(buildSupportFeatureKey(userId)) === '1';
};

export const markSupportConversationsFeatureSeen = (userId) => {
  if (typeof window === 'undefined' || !userId) return;
  window.localStorage.setItem(buildSupportFeatureKey(userId), '1');
};
